import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.operationstransformation.com.au";
const DEFAULT_TITLE = "Operations Transformation Program | Transform. Apply. Qualify.";
const DEFAULT_DESC =
  "A practitioner-built operations transformation system for leaders in mining, heavy industry and complex operations. Complete the nationally recognised BSB50420 Diploma of Leadership and Management, delivered and assessed by Axiom College (RTO 40489).";

/**
 * Per-route SEO / meta. Blog & article pages can reuse this with their own
 * title/description/canonical/image to control indexing and social sharing.
 */
export const Seo = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESC,
  path = "/",
  image = `${SITE}/og-image.jpg`,
  noindex = false,
  type = "website",
}) => {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
